import { render } from "./client-services-person.vue?vue&type=template&id=51607709&ts=true"
import script from "./client-services-person.ts?vue&type=script&lang=ts&external"
export * from "./client-services-person.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__